import React, { HtmlHTMLAttributes } from 'react';
import Footer from '../components/footer';
import Header from '../components/header';
import LeftMenu from '../components/leftMenu';
interface LayoutProps extends HtmlHTMLAttributes<HTMLDivElement> {

}
const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div id="layout-wrapper" className='position-relative min-vh-100'>
            <Header />
            <LeftMenu />

            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        {children}
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default Layout;